/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "pairName",
                        type: "string",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "collateralPerPair",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceIdentifier",
                        type: "bytes32",
                    },
                    {
                        internalType: "bool",
                        name: "enableEarlyExpiration",
                        type: "bool",
                    },
                    {
                        internalType: "contract ExpandedIERC20",
                        name: "longToken",
                        type: "address",
                    },
                    {
                        internalType: "contract ExpandedIERC20",
                        name: "shortToken",
                        type: "address",
                    },
                    {
                        internalType: "contract IERC20",
                        name: "collateralToken",
                        type: "address",
                    },
                    {
                        internalType: "contract LongShortPairFinancialProductLibrary",
                        name: "financialProductLibrary",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "customAncillaryData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "proposerReward",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "optimisticOracleLivenessTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "optimisticOracleProposerBond",
                        type: "uint256",
                    },
                    {
                        internalType: "contract FinderInterface",
                        name: "finder",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "timerAddress",
                        type: "address",
                    },
                ],
                internalType: "struct LongShortPair.ConstructorParams",
                name: "params",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "ContractExpired",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "earlyExpirationTimeStamp",
                type: "uint64",
            },
        ],
        name: "EarlyExpirationRequested",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "collateralReturned",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "longTokens",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shortTokens",
                type: "uint256",
            },
        ],
        name: "PositionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralUsed",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokensMinted",
                type: "uint256",
            },
        ],
        name: "TokensCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralReturned",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokensRedeemed",
                type: "uint256",
            },
        ],
        name: "TokensRedeemed",
        type: "event",
    },
    {
        inputs: [],
        name: "collateralPerPair",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokensToCreate",
                type: "uint256",
            },
        ],
        name: "create",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralUsed",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "customAncillaryData",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "earlyExpirationTimestamp",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "enableEarlyExpiration",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "expirationTimestamp",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "expire",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "expiryPercentLong",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "expiryPrice",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "financialProductLibrary",
        outputs: [
            {
                internalType: "contract LongShortPairFinancialProductLibrary",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "finder",
        outputs: [
            {
                internalType: "contract FinderInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getEarlyExpirationAncillaryData",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "getPositionTokens",
        outputs: [
            {
                internalType: "uint256",
                name: "longTokens",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "shortTokens",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ignoreEarlyExpirationPrice",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "isContractEarlyExpired",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "longToken",
        outputs: [
            {
                internalType: "contract ExpandedIERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "optimisticOracleLivenessTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "optimisticOracleProposerBond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pairName",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "priceIdentifier",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposerReward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "receivedSettlementPrice",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokensToRedeem",
                type: "uint256",
            },
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralReturned",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "_earlyExpirationTimestamp",
                type: "uint64",
            },
        ],
        name: "requestEarlyExpiration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "setCurrentTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "longTokensToRedeem",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "shortTokensToRedeem",
                type: "uint256",
            },
        ],
        name: "settle",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralReturned",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "shortToken",
        outputs: [
            {
                internalType: "contract ExpandedIERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
export class LongShortPair__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(params, overrides) {
        return super.deploy(params, overrides || {});
    }
    getDeployTransaction(params, overrides) {
        return super.getDeployTransaction(params, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
LongShortPair__factory.bytecode = _bytecode;
LongShortPair__factory.abi = _abi;
